export default __webpack_public_path__ + "static/media/cross-red.2f5be68d.png";